import { LockOffIcon } from '@vlabs/icons';

import st from './shared.module.sass';

interface PermissionTagCellProps {
  permissionTag: string;
}

function PermissionTagCell({
  permissionTag,
}: PermissionTagCellProps): JSX.Element {
  return (
    <div className={st.PermissionTagCell}>
      <LockOffIcon className={st.LockIcon} />
      <span className={st.PermissionTagName}>{permissionTag}</span>
    </div>
  );
}

export { PermissionTagCell };
